import Accept from './Accept';

export default Accept;
